// This file is generated.
export var version = '1.79.0';
//# sourceMappingURL=version.js.map